import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {
  AdminMenuLayout,
  ModalProductCategories,
} from "../../../shared/components";
import { WrapperCardCategories } from "./styled";
import { TableProductCategories } from "./TableProductCategories";
import { useSelector } from "react-redux";
import { selectModalProductCategories } from "../../../redux";
import { useProductCategories } from "../hooks";
import { FormProvider } from "react-hook-form";
import { productCategoriesService } from "../../../shared/services";

export const ProductCategories = () => {
  const modalProductCategories = useSelector(selectModalProductCategories);
  const {
    isUpdateProductCategory,
    formMethodsCreate,
    formMethodsUpdate,
    changeModalProductCategoriesState,
  } = useProductCategories();

  return (
    <AdminMenuLayout
      pageDescription="ProductCategories"
      title="ProductCategories"
    >
      <WrapperCardCategories>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={changeModalProductCategoriesState}
            >
              Agregar nueva categoría
            </Button>
          </Col>
        </Row>
        <TableProductCategories />
        {modalProductCategories && isUpdateProductCategory && (
          <FormProvider {...formMethodsUpdate}>
            <ModalProductCategories />
          </FormProvider>
        )}
        {modalProductCategories && !isUpdateProductCategory && (
          <FormProvider {...formMethodsCreate}>
            <ModalProductCategories />
          </FormProvider>
        )}
      </WrapperCardCategories>
    </AdminMenuLayout>
  );
};
